<div class="save-container">
    <div class="save-btn" (click)="openSaveSurveyModal()">
        <p><i class="fa-solid fa-floppy-disk"></i> Salva ricerca</p>
    </div>
</div>